"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author tatevik.marikyan
 * @since 12/03/2018
 */
var core_1 = require("@angular/core");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var of_1 = require("rxjs/observable/of");
var zip_1 = require("rxjs/observable/zip");
var operators_1 = require("rxjs/operators");
var model_1 = require("../../../controls/entity-search/model");
var service_1 = require("../../api/service");
var utilities_1 = require("../../utilities");
var model_2 = require("../model");
var PortfolioSerializationService = /** @class */ (function () {
    function PortfolioSerializationService(_kbService, _languageService, _classifierService, _portfolioService) {
        this._kbService = _kbService;
        this._languageService = _languageService;
        this._classifierService = _classifierService;
        this._portfolioService = _portfolioService;
        this._entityBuilder = new idm_de_core_frontend_1.EntityBuilder();
    }
    PortfolioSerializationService.prototype.deserializeEntities = function (systemName, entitiesDataObservable, compoundMainEntityfields, categoryPermissionTypes) {
        var _this = this;
        var serviceResponse = new model_2.ServiceResponseDefault();
        return entitiesDataObservable.pipe(operators_1.switchMap(function (entitiesData) {
            serviceResponse.setMeta(utilities_1.deserializeMeta(entitiesData.meta));
            if (entitiesData.data.length > 0) {
                var entityObservables = entitiesData.data.map(function (entityData) {
                    return _this.deserializeEntity(systemName, entityData, compoundMainEntityfields, categoryPermissionTypes);
                });
                return zip_1.zip.apply(void 0, entityObservables);
            }
            else {
                return of_1.of([]);
            }
        }), operators_1.switchMap(function (data) {
            serviceResponse.setData(data);
            return of_1.of(serviceResponse);
        }));
    };
    PortfolioSerializationService.prototype.deserializeEntitySearchItems = function (entitySearchItemsData$, filterFields, nestedEntityInstanceName) {
        var serviceResponse = new model_2.ServiceResponseDefault();
        return entitySearchItemsData$.pipe(operators_1.map(function (entitiesData) {
            var searchItems;
            if (entitiesData.data.length > 0) {
                searchItems = entitiesData.data.map(function (entityItem) {
                    var filterFieldData = filterFields.map(function (filterField) {
                        return entityItem[filterField];
                    });
                    return new model_1.EntitySearchItem(entityItem[nestedEntityInstanceName], filterFieldData.join(' | '), entityItem);
                });
            }
            var meta = new model_2.Meta();
            meta.setTotalRowCount(entitiesData.meta.totalRowCount);
            serviceResponse.setMeta(meta);
            serviceResponse.setData(searchItems);
            return serviceResponse;
        }));
    };
    PortfolioSerializationService.prototype.deserializeEntity = function (systemName, entityData, compoundMainEntityfields, categoryPermissionTypes) {
        var _this = this;
        var entityFieldsObservable = this._kbService.getMetaFields(systemName);
        var languagesObservable = this._languageService.getInputLanguages();
        return zip_1.zip(entityFieldsObservable, languagesObservable).pipe(operators_1.switchMap(function (data) {
            var entityFields = compoundMainEntityfields === undefined
                ? data[0]
                : compoundMainEntityfields;
            var languages = data[1];
            var entity = _this._entityBuilder.createEntity(model_2.MainEntity, entityFields);
            entity = idm_de_core_frontend_1.deserializeSimpleFields(entityFields, languages, entity, entityData);
            return _this.deserializeCompoundFields(systemName, entityFields, entity, entityData, categoryPermissionTypes);
        }));
    };
    PortfolioSerializationService.prototype.deserializeCompoundFields = function (systemaName, entityFields, entity, entityData, categoryPermissionTypes) {
        var _this = this;
        var entityCompoundFields = entityFields
            .filter(utilities_1.isCompoundField)
            .filter(function (field) {
            return utilities_1.isFieldValueNotEmpty(field, entity);
        });
        if (entityCompoundFields.length > 0) {
            var entityCompoundFieldObservables = entityCompoundFields.map(function (field) {
                return _this.deserializeCompoundField(systemaName, field, entityData[field.getSystemName()], categoryPermissionTypes);
            });
            return zip_1.zip.apply(void 0, entityCompoundFieldObservables).pipe(operators_1.map(function (fieldValues) {
                entityCompoundFields.forEach(function (field, index) {
                    entity.getProperty(field.getSystemName()).value =
                        fieldValues[index];
                });
                return entity;
            }));
        }
        else {
            return of_1.of(entity);
        }
    };
    PortfolioSerializationService.prototype.deserializeCompoundField = function (systemName, field, fieldData, categoryPermissionTypes) {
        var _this = this;
        var fieldType = field.getType();
        switch (fieldType) {
            case idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER:
            case idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE: {
                return this._classifierService.loadClassifier(field.getCompoundCategorySystemName(), fieldData);
            }
            case idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY: {
                return this.deserializeCompoundMainEntity(systemName, field, fieldData, categoryPermissionTypes);
            }
            case idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT:
                var classifierObservables = fieldData.map(function (itemData) {
                    return _this._classifierService.loadClassifierDependencies(field.getCompoundCategorySystemName(), itemData);
                });
                return zip_1.zip.apply(void 0, classifierObservables).pipe(operators_1.switchMap(function (classifierEntities) {
                    return of_1.of(classifierEntities);
                }));
            case idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY: {
                var subEntityObservables = fieldData.map(function (itemData) {
                    return _this.deserializeEntity(field.getCompoundCategorySystemName(), itemData, undefined, categoryPermissionTypes);
                });
                return zip_1.zip.apply(void 0, subEntityObservables).pipe(operators_1.switchMap(function (subEntities) {
                    return of_1.of(subEntities);
                }));
            }
            default: {
                throw new Error("Illegal field type " + field.getType() + " was provided.");
            }
        }
    };
    PortfolioSerializationService.prototype.deserializeCompoundMainEntity = function (systemName, field, fieldData, categoryPermissionTypes) {
        var _this = this;
        var metaFields$ = this._kbService.getMetaFields(field.getCompoundCategorySystemName());
        var compoundMainEntityMetaFields$ = this._kbService.getMainEntityMetaFields(systemName, field.getSystemName());
        return zip_1.zip(metaFields$, compoundMainEntityMetaFields$).pipe(operators_1.switchMap(function (data) {
            var metaFieldSystemName;
            data[0].forEach(function (metaField) {
                if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.INTEGER_INSTANCE) {
                    metaFieldSystemName = metaField.getSystemName();
                }
            });
            if (metaFieldSystemName !== undefined &&
                metaFieldSystemName !== null) {
                var filterBuilder = new idm_de_core_frontend_1.FilterBuilder();
                filterBuilder.is(metaFieldSystemName, fieldData);
                var mainEntityItems$ = _this._portfolioService.loadPortfolioItems(field.getCompoundCategorySystemName(), new idm_de_core_frontend_1.PagingOptions(0, 1), null, filterBuilder.build().toJson(), categoryPermissionTypes, data[1]);
                return mainEntityItems$.pipe(operators_1.map(function (value) {
                    return value.getData().length > 0
                        ? value.getData()[0]
                        : null;
                }));
            }
            else {
                return of_1.of(null);
            }
        }));
    };
    PortfolioSerializationService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_kb_service_client_js_1.KbService,
            idm_message_language_service_client_js_1.LanguageService,
            idm_classifier_service_client_js_1.ClassifierService,
            service_1.PortfolioService])
    ], PortfolioSerializationService);
    return PortfolioSerializationService;
}());
exports.PortfolioSerializationService = PortfolioSerializationService;
//# sourceMappingURL=portfolio-serialization.service.js.map